import CatchCopy from 'assets/images/hero_section/top_catch_copy.png';
import styles from 'styles/HeroSection.module.css';

const HeroSection = () => {
  return (
    <div className={styles["hero-section-background"]}>
      <div className={styles["hero-section"]}>
        <img src={CatchCopy} alt="ここがエリアの最高峰" draggable="false"/>
        <div className={styles["scroll-indicator"]}>
          <div className={styles["line"]}></div>
          <p>SCROLL</p>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
